<template>
    <div
        v-if="attachment"
        id="poll"
    >
        <f7-block-title style="color: black; margin: 0 16px; padding-top: 6px; font-weight: 300; line-height: 40px">POLL</f7-block-title>
        <f7-block class="answers">
            <h2
                style="margin-top: -5px; text-align: left; position: relative; z-index: 15"
                v-html="attachment.title.replace(/<[^>]*>?/gm, '')"
            />
            <template v-for="(answer, answerIndex) in attachment.data.answers">
                <div
                    :key="'answer-'+answerIndex"
                    :class="`answer answer-${attachment.id}-${answerIndex} ${showedGraph ? 'answered' : ''}`"
                    @click="postAnswer(answerIndex, $event)"
                >
                    <div class="answerText">{{ answer.title }}</div>
                    <div
                        :class="`answerGraph color-${answerIndex}`"
                        :style="`${answer.width ? `width: ${answer.width}%` : 'width: 0%'}`"
                    />
                    <div
                        class="answerPc"
                        v-html="answer.answerPc || ''"
                    />
                </div>
            </template>
            <br style="clear: both">
            <span
                v-if="total"
                class="total"
            >{{ total }} respondents</span>

            <!-- <img
                src="../img/1.2.0/pollsBg.png"
                style="width: 500px; position: absolute; bottom: -30px; left: -230px;"
            > -->
        </f7-block>
    </div>
</template>

<script>
// Note: Some of this code was taken from an old project of Eti's

export default {
    props: ['attachment'],
    store: ['api', 'user', 'traits', 'myTraits', 'myValueTraits', 'home',],
    data () {
        return {
            isResponded: false,
            showedGraph: false,
            total: 0,
            lastPoll: 0,
        };
    },
    watch: {},
    mounted: function () {
        this.answerIfLast();
    },
    methods: {
        answerIfLast: function () {
            if (localStore.getItem('last-poll')) {
                this.lastPoll = parseFloat(localStore.getItem('last-poll'));
            }
            if (this.lastPoll && this.lastPoll === this.attachment.id) {
                let total = 0;
                for (let i = 0; i < this.attachment.data.answers.length; i++) {
                    const answer = this.attachment.data.answers[i];
                    total = total + parseFloat(answer.total);
                }
                this.total = total;
                this.showGraph();
            }
        },
        postAnswer: function (index) {
            if (this.isResponded) return;
            this.isResponded = true;
            this.showGraph();
            this.$events.fire('trackEvent', `daily_poll`, 'daily', this.attachment.id, this.attachment.title, {
                question: this.attachment.title.replace(/(<([^>]+)>)/ig, ""),
                questionId: this.attachment.id,
                answerIndex: index,
                answer: this.attachment.data.answers[index].title,
            })
            if (!this.user.id) return console.log('Must be logged to answer.');
            this.attachment.myAnswer = {
                questionId: this.attachment.id,
                slideId: 0,
                choiceInt: index
            };
            this.$http
                .post(`${this.api}/results`, {
                    questionId: this.attachment.id,
                    slideId: 0,
                    choiceInt: index,
                    tracker: false,
                    day: this.user.day
                })
                .then(() => {
                    localStore.setItem('last-poll', this.attachment.id);
                }, () => {

                });

        },
        showGraph: function () {
            let total = 0;
            let maxPc = 0;
            let multiplier = 1;
            for (let i = 0; i < this.attachment.data.answers.length; i++) {
                const answer = this.attachment.data.answers[i];
                total = total + parseFloat(answer.total);
            }
            for (let i = 0; i < this.attachment.data.answers.length; i++) {
                const answer = this.attachment.data.answers[i];
                answer.percentage = parseFloat(answer.total * 100 / total);
                answer.answerPc = '';
                answer.width = 0;
                if (answer.percentage > maxPc) maxPc = answer.percentage;
            }
            if (maxPc < 20) multiplier = 3;
            else if (maxPc < 30) multiplier = 2.5;
            else if (maxPc < 40) multiplier = 1.8;
            else if (maxPc < 49) multiplier = 1.2;
            if (total < 10) multiplier = 1;
            setTimeout(() => {
                for (let i = 0; i < this.attachment.data.answers.length; i++) {
                    const answer = this.attachment.data.answers[i];
                    if (answer.percentage > 100) answer.percentage = 100;
                    if (answer.percentage < 0) answer.percentage = 0;

                    Vue.set(this.attachment.data.answers[i], 'percentage', answer.percentage);
                    Vue.set(this.attachment.data.answers[i], 'answerPc', answer.percentage.toFixed(0) + '%');
                    Vue.set(this.attachment.data.answers[i], 'width', parseFloat(answer.percentage * multiplier, 2));
                }
                this.total = total;
                this.showedGraph = true;
            }, 200);
        },
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
#poll {
    padding-bottom: 70px;
    h2 {
        position: relative;
        z-index: 15;
        text-align: left;
        font-family: Editor-Bold;
        font-style: normal;
        font-weight: bold;
        font-size: 21px;
        line-height: 26px;
        margin: 0 0 8px;
    }
    position: relative;
    background: #efc6ab;
    .answer {
        color: black;
        cursor: pointer;
        float: left;
        clear: left;
        width: 100%;
        display: block;
        min-width: 100%;
        font-family: AndesMedium;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 15px;
        text-align: center;
        text-transform: uppercase;

        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #edeae9;
        border-top: 2px solid #efc6ab;
        position: relative;
        &:last-of-type {
            height: 46px;
            border-bottom: 2px solid #efc6ab;
        }
    }
    .theme-dark {
        .answer {
            background: transparent;
            color: white;
        }
    }
    .answerText {
        font-family: AndesMedium;

        z-index: 10;
        position: absolute;
        width: 100%;
        transition: width 0.8s ease;
    }
    .answerPc {
        height: 44px;
        position: absolute;
        font-family: AndesMedium;
        top: 0px;
        right: 16px;
        display: none;
        opacity: 0;
        font-size: 13px;
        color: #888;
        transition: opacity 0.8s ease;
        z-index: 10;
    }
    .answered {
        .answerText {
            padding-left: 16px;
            width: 0;
            white-space: nowrap;
        }
        .answerPc {
            display: inline;
            opacity: 1;
        }
    }
    .answers {
        margin: 0 16px;
        padding: 0 0 100px;
    }
    .answerGraph {
        z-index: 9;
        height: 42px;
        width: 0px;
        position: absolute;
        top: 0px;
        left: 0px;
        transition: 1s;
    }
    .answerGraph {
        background-color: #80a89f;
    }
    .answerGraph.color-1 {
        background-color: #f09372;
    }
    .answerGraph.color-2 {
        background-color: #d9ccc4;
    }
    .answerGraph.color-3 {
        background-color: #f7f4f3;
    }
    .answerGraph.color-3 {
        background-color: #ff6f61;
    }
    .total {
        font-family: AndesBook;
        font-size: 12px;
        color: #1a211e;
        line-height: 52px;
        text-transform: none;
        float: right;
    }
}
</style>
